import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ChatIcon } from "../../assets/SideBar/chatIcon.svg";
import { ReactComponent as CompaniesIcon } from "../../assets/SideBar/comanies.svg";
import { ReactComponent as DashboardIcon } from "../../assets/SideBar/dashboard.svg";
import { ReactComponent as LogoutIcon } from "../../assets/SideBar/logout.svg";
import { ReactComponent as Posts } from "../../assets/SideBar/posts.svg";
import { ReactComponent as SpecialistsIcon } from "../../assets/SideBar/specialists.svg";
import { ReactComponent as SessionsIcon } from "../../assets/SideBar/swarm-session.svg";
import { ReactComponent as UsersIcon } from "../../assets/SideBar/users.svg";
import { ContextProvider } from "../../contextProvider";
import { logout } from "../../utils/general";
import AllToolsPopup from "./AllToolsPopup";
import "./SideBar.css";

const menuItems = [
  {
    icon: <DashboardIcon width={20} height={20} />,
    label: "Dashboard",
    description: "General inforamtion and specialists approvals",
    route: "/dashboard",
    badge: { title: "dashboard", description: "dashboard" },
  },
  {
    icon: <UsersIcon width={20} height={20} />,
    label: "Users",
    description: "Manage platform users",
    route: "/users",
    badge: { title: "users", description: "new users" },
  },
  {
    icon: <SpecialistsIcon width={20} height={20} />,
    label: "Specialists",
    description: "Manage platform specialists",
    route: "/specialists",
    badge: { title: "specialists", description: "ready to review specialists" },
  },
  {
    icon: <SessionsIcon width={20} height={20} />,
    name: "Sessions",
    label: "Sessions",
    description: "Information about sessions and decisions on unheld sessions",
    route: "/sessions",
  },
  {
    icon: <CompaniesIcon width={20} height={20} />,
    name: "Companies",
    label: "Companies",
    description: "Company and project management",
    route: "/companies",
  },
  {
    icon: <ChatIcon width={20} height={20} />,
    label: "Chat",
    description: "Global chat with client and specialists",
    route: "/chat",
    badge: { title: "chat", description: "new messages" },
  },

  {
    icon: <Posts width={20} height={20} />,
    label: "All Tools",
    description: "Open all available tools",
    isAllTools: true,
  },
];

const SideBar = () => {
  const { readyToReview, unreadMesssageAmount, userData } =
    useContext(ContextProvider);
  const [showAllTools, setShowAllTools] = useState(false);
  const [sidebarBadges, setSidebarBadges] = useState<Record<string, number>>(
    {},
  );

  const setSidebarBadge = (badgeName: string, count: number) => {
    setSidebarBadges((prev) => ({ ...prev, [badgeName]: count }));
  };

  useEffect(() => {
    // TODO: @kasevl  add logic to fetch counts
    setSidebarBadge("chat", unreadMesssageAmount); // Example: 5 unread messages
    setSidebarBadge("specialists", readyToReview); // Example: 3 specialists ready to review
  }, []);

  return (
    <div className="sidebar">
      {menuItems.map((item, i) => {
        const badgeCount = item.badge?.title
            ? sidebarBadges[item.badge.title]
            : 0,
          badge =
            badgeCount > 0 ? <span className="badge">{badgeCount}</span> : null,
          badgeDescription =
            badge && item.badge?.description ? (
              <p className="badge-description">
                {badgeCount} {item.badge.description}
              </p>
            ) : null;

        const icon = (
          <div className="tooltip">
            {item.icon}
            {badge}
            <div className="tooltip-content">
              <strong>{item.label}</strong>
              <p>{item.description}</p>
              {/*       <br />
              {badgeDescription} */}
            </div>
          </div>
        );

        return (
          <div
            key={i}
            className="sidebar-icon"
            onClick={() => item.isAllTools && setShowAllTools(true)}
          >
            {item.route ? <Link to={item.route}>{icon}</Link> : icon}
          </div>
        );
      })}

      {showAllTools && <AllToolsPopup onClose={() => setShowAllTools(false)} />}
      <div
        className="logoutBtn"
        role="button"
        onClick={() => logout(userData?._id ?? "")}
      >
        <LogoutIcon />
      </div>
    </div>
  );
};

export { menuItems };
export default SideBar;
